import NavigationDiallerContainerComponent from "./NavigationDiallerContainer.component";

export * from "./NavigationDiallerContainer.component";
export default NavigationDiallerContainerComponent;